// Treaties between houses (`diplomacy.basic`) — English. Merged in ./messages.ts.

export const gameTreatyEn = {
  'treaty.war': 'at war',
  'treaty.pact': 'pact',
  'treaty.alliance': 'allied',
  'treaty.federation': 'federation',
  'treaty.propose.peace': 'Propose peace',
  'treaty.propose.pact': 'Propose a pact',
  'treaty.propose.alliance': 'Propose an alliance',
  'treaty.sent': 'Offer sent',
  'treaty.noPoints': 'Not enough diplomacy points',
  'treaty.points': 'Diplomacy points {points}/{max} · an offer costs {cost}',
  'treaty.of.neutral': 'peace',
  'treaty.of.pact': 'a non-aggression pact',
  'treaty.of.alliance': 'an alliance',
  'treaty.of.federation': 'a federation',
  'treaty.of.war': 'war',
  'treaty.offerTitle': '{house} offers {treaty}',
  'treaty.war.declare': 'Declare war',
  'treaty.war.confirm': 'Confirm war (−{honor} honor)',
  'treaty.war.cancel': 'Cancel',
  'treaty.news.accepted': '{house} accepted {treaty}',
  'treaty.news.declined': '{house} declined {treaty}',
  'treaty.news.expired': 'Your offer to {house} lapsed',
  'treaty.news.wed': '{house} accepted your marriage',
  'treaty.news.refused': '{house} refused your marriage',
  'treaty.news.lapsed': 'Your marriage offer to {house} lapsed',
  'treaty.news.war': 'War with {house}',
  'treaty.news.taken': 'You have {treaty} with {house}',
  'treaty.news.void': '{house} offered {treaty} and it could not be taken',
  'treaty.news.stale': 'That offer from {house} was no longer on the table',
  'treaty.accept': 'Accept',
  'treaty.decline': 'Decline',
} as const;
